import { render, staticRenderFns } from "./SLItemNotes.vue?vue&type=template&id=22e23b12&"
import script from "./SLItemNotes.vue?vue&type=script&lang=js&"
export * from "./SLItemNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports